<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import appConfig from "@/app.config";
import {orderService} from "@/services/authservice/order";
import {commonService} from "@/services/common";
import UtilsMixin from "@/mixins/utils";
import Multiselect from "vue-multiselect";
import {accountService} from "@/services/authservice/account";
import DatePicker from "vue2-datepicker";
import {brandService} from "@/services/authservice/brand";

export default {
  page: {
    title: "Chuyển người giao hàng",
    meta: [{name: "description", content: appConfig.description}],
  },
  mixins: [UtilsMixin],
  components: {Layout, PageHeader, TableLoading, TableEmpty, Multiselect, DatePicker},
  data() {
    return {
      listData: [],
      listRegion: [],
      title: "Chuyển người giao hàng",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Chuyển người giao hàng",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        {key: "checkbox", label: "Check"},
        {key: "po_id", label: "Mã đơn"},
        {key: "customer_name", label: "Khách hàng"},
        {key: "delivery", label: "Địa chỉ giao hàng"},
        {key: "region_uid", label: "Khu vực"},
        {key: "require_time", label: "Thời gian giao"},
        {key: "status", label: "Trạng thái"},
      ],
      isBusy: false,
      me: {},
      selectedOrder: [],
      selectedPrintPO: [],
      isSelectedAll: false,
      listShipperAll: [],
      listShipper: [],
      listSalesman: [],
      listBrand: [],
      searchData: {
        id: "",
        shipper_id: "",
        date: [],
        brand: "",
        salesman: "",
      },
      formData: {
        shipper: ""
      },
      distributorInfo: {},
      isLoadingPrint: false,
      isLoadingCombine: false,
      poHasItem: [],
      itemEditQuantity: "",
      totalQuantityItem: 0,
      isBtnLoadingShip: false,
      isCheckChangeShip: false,
      isFirstSession: true,
    };
  },
  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    this.getList();
  },
  computed: {
    rows() {
      return this.listData.length;
    },
  },
  mounted() {
    this.totalRows = this.listData.length;
  },
  methods: {

    onFiltered() {
      this.totalRows = this.listData.length;
      this.currentPage = 1;
    },

    async getList() {
      this.isBusy = true;
      const regionPromise = commonService.getListRegion();
      const shipperPromise = accountService.getList({'role_id': 'SHIPPER'});
      const salesmanPromise = accountService.getList({'role_id': 'SALESMAN'});
      const brandPromise = brandService.getList();
      // get list region
      const responseRegion = await regionPromise;
      if (responseRegion.data.error) {
        this.listRegion = [];
      } else {
        this.listRegion = responseRegion.data.data;
      }

      // get list shipper
      const resShipper = await shipperPromise;
      if (resShipper.data.error) {
        this.listShipper = [];
        this.listShipperAll = [];
      } else {
        this.listShipper = resShipper.data.data;
        this.listShipperAll = resShipper.data.data;
      }

      // get list salesman
      const resSalesman = await salesmanPromise;
      if (resSalesman.data.error) {
        this.listSalesman = [];
      } else {
        this.listSalesman = resSalesman.data.data;
      }

      // get list brand
      const resBrand = await brandPromise;
      if (resBrand.data.error) {
        this.listBrand = [];
      } else {
        this.listBrand = resBrand.data.data;
      }

      this.isBusy = false;
    },

    async getDataTable() {
      let start = "";
      let end = "";
      if (this.searchData.date.length > 0 && this.searchData.date[0] && this.searchData.date[1]) {
        start = this.searchData.date[0].setHours(0, 0, 0, 0);
        end = this.searchData.date[1].setHours(23, 59, 59, 999);
      }
      let param = {
        'list_po_type': 'CUSTOMER,AGENCY',
        'po_id': this.searchData.id.trim() !== "" ? this.searchData.id : "",
        'shipper_id': this.searchData.shipper_id ? this.searchData.shipper_id.email : "",
        'warehouse_uid': this.me['warehouse_uid'],
        "created_by": this.searchData.salesman ? this.searchData.salesman.email : "",
        'trademark_uid': this.searchData.brand ? this.searchData.brand.id : "",
        'from_timestamp': start,
        'to_timestamp': end,
        "status": 'CONFIRMED',
        'results_per_page': 1000
      }

      const res = await orderService.getListOrder(param);
      if (res.data.error) {
        this.listData = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data.error.message,
        });
      } else {
        this.listData = res.data.data;
      }
      this.isBusy = false;
    },

    renderRegion(id) {
      const find = this.listRegion.find(e => e.id === id);
      return find ? find.region_name : "-";
    },

    onSelectOrder(id) {
      this.selectedPrintPO = this.listData.filter(e => id.includes(e.id));
    },

    onSelectAll(value) {
      this.selectedOrder = [];
      this.selectedPrintPO = [];
      if (value) {
        this.selectedOrder = this.listData.map(e => e.id);
        this.selectedPrintPO = this.listData;
      }
    },

    async onSearch() {
      if (this.searchData.shipper_id !== "" && this.searchData.shipper_id) {
        this.isFirstSession = false;
        this.isBusy = true;
        this.selectedOrder = [];
        this.selectedPrintPO = [];
        this.isSelectedAll = false;
        await this.getDataTable();
        this.listShipper = this.listShipperAll.filter(e => e.id !== this.searchData.shipper_id.id);
        this.isBusy = false;
      }
    },

    async onResetSearch() {
      this.isBusy = true;
      this.currentPage = 1;
      this.searchData = {
        id: "",
        shipper_id: "",
        date: [],
        brand: "",
        salesman: "",
      }
      this.listData = [];
      this.isFirstSession = true;
      this.isBusy = false;
    },

    onChangeShip() {
      this.isCheckChangeShip = false;
      if (this.selectedPrintPO.length > 0) {
        this.$bvModal.show("md-confirm-ship");
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title: "Vui lòng chọn đơn hàng muốn chuyển",
        });
      }
    },

    async onConfirmChangeShipper() {
      if (this.formData.shipper !== "" && this.formData.shipper) {
        this.isCheckChangeShip = true;
        const newArr = this.selectedPrintPO.map(e => {
          return {
            id: e.id,
            status: e.status,
            shipper_id: this.formData.shipper.email,
            shipper_name: this.formData.shipper.name,
            shipper_phone: this.formData.shipper.phone,
          };
        });
        const res = await orderService.update({list_po: newArr});
        if (res.data.data) {
          this.isCheckChangeShip = false;
          this.onSearch();
          this.$notify({
            group: "app",
            type: "success",
            title: "Chuyển người giao hàng thành công",
          });
          this.$bvModal.hide("md-confirm-ship");
        } else {
          this.isCheckChangeShip = false;
          this.$notify({
            group: "app",
            type: "error",
            title: "Đơn hàng có lỗi, vui lòng kiểm tra lại",
          });
        }
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title: "Vui lòng chọn giao hàng",
        });
      }
    },

    hideModal() {
      this.formData.shipper = "";
      this.$bvModal.hide("md-confirm-ship");
    },

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-12">
                <!--Search form-->
                <form>
                  <div class="row">
                    <div class="col-12" style="display: contents">
                      <div class="form-group mt-0 mb-2 mr-2">
                        <multiselect
                            :max-height="150"
                            id="shipInfo"
                            v-model="searchData.shipper_id"
                            :options="listShipperAll"
                            track-by="id"
                            label="name"
                            placeholder="Chọn giao hàng"
                            noOptions="Danh sách trống"
                            :allowEmpty="false"
                            :show-labels="false"
                            class="min-w-200"
                        ></multiselect>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <b-input
                            @keydown.enter.native="onSearch"
                            type="text"
                            class="form-control"
                            placeholder="Mã đơn"
                            v-model="searchData.id"
                        />
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2 min-w-200">
                        <date-picker
                            v-model="searchData.date"
                            :first-day-of-week="1"
                            lang="en"
                            range
                            format="DD/MM/YYYY"
                            placeholder="Chọn khoảng thời gian"
                            :shortcuts="shortcuts"
                        ></date-picker>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                            :max-height="150"
                            id="salesman"
                            v-model="searchData.salesman"
                            :options="listSalesman"
                            track-by="id"
                            label="name"
                            placeholder="Chọn salesman"
                            noOptions="Danh sách trống"
                            :show-labels="false"
                            class="min-w-200"
                        ></multiselect>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                            :max-height="150"
                            v-model="searchData.brand"
                            :options="listBrand"
                            track-by="id"
                            label="trademark_name"
                            placeholder="Chọn nhãn hàng"
                            noOptions="Danh sách trống"
                            :show-labels="false"
                            class="min-w-200"
                        ></multiselect>
                      </div>
                      <div class="mt-0">
                        <button type="button" class="btn btn-primary" @click="onSearch">Lọc</button>
                        <button type="button" class="ml-2 btn btn-secondary" @click="onResetSearch">
                          <i class="bx bx-revision"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <template v-if="isFirstSession">
              <div class="row">
                <div class="col-12">
                  <p class="mb-0 mt-4 text-muted font-size-16 font-italic">
                    Vui lòng chọn giao hàng và ấn Lọc để tiếp tục</p>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- ACTION -->
              <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Hiện
                      <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                      ></b-form-select
                      >&nbsp;mục
                    </label>
                  </div>
                </div>
                <!-- Action -->
                <div class="col-sm-12 col-md-6">
                  <div class="row mb-2">
                    <div class="col-lg-12">
                      <div class="d-flex justify-content-end">
                        <button
                            @click="onChangeShip"
                            type="button"
                            class="btn btn-light">
                          <i class="bx bxs-truck font-size-16 align-middle mr-2"></i> Chuyển người giao hàng
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End add new -->
              </div>
              <!-- TABLE DATA -->
              <div class="table-responsive mb-0">
                <b-table
                    show-empty
                    :items="listData"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    :busy="isBusy"
                    table-class="scroll-table"
                >
                  <template v-slot:table-busy>
                    <TableLoading/>
                  </template>
                  <template v-slot:empty>
                    <TableEmpty/>
                  </template>
                  <template v-slot:cell(index)="row">
                    {{ row.index + 1 }}
                  </template>
                  <template v-slot:head(checkbox)="row">
                    <b-form-checkbox
                        @change="onSelectAll($event)"
                        v-model="isSelectedAll"
                        name="selected-order"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(checkbox)="row">
                    <b-form-checkbox
                        :id="row.item.id"
                        v-model="selectedOrder"
                        @change="onSelectOrder($event)"
                        name="selected-order"
                        :key="row.item.id"
                        :value="row.item.id"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(po_id)="row">
                    <router-link :to="{ name: 'OrderDetail', params: { id: row.item.id }}">
                      {{ row.item.po_id }}
                    </router-link>
                  </template>
                  <template v-slot:cell(delivery)="row">
                    {{ row.item.delivery_info ? row.item.delivery_info.delivery_address : '-' }}
                  </template>
                  <template v-slot:cell(region_uid)="row">
                    {{ renderRegion(row.item.region_uid) }}
                  </template>
                  <template v-slot:cell(require_time)="row">
                    {{ formatDateUnix(row.item.require_time) }}
                  </template>
                  <template v-slot:cell(created_at)="row">
                    {{ formatDateUnix(row.item.created_at) }}
                  </template>
                  <template v-slot:cell(status)="row">
                  <span class="badge badge-pill p-2 text-uppercase"
                        :class="renderStatus(row.item.status)[1]">
                    {{ renderStatus(row.item.status)[0] }}
                  </span>
                  </template>
                </b-table>
              </div>
              <!-- PAGING -->
              <div class="row">
                <div class="col">
                  <div class="mt-3 float-right">
                    <b-pagination
                        class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- Xác nhận chuyển giao hàng -->
    <b-modal id="md-confirm-ship" title="Xác nhận chuyển giao hàng" centered hide-footer>
      <div class="row">
        <div class="col-lg-12">
          <multiselect
              v-model="formData.shipper"
              :options="listShipper"
              track-by="id"
              label="name"
              placeholder="Chọn giao hàng"
              noOptions="Danh sách trống"
              :show-labels="false"
              :allowEmpty="false"
              class="mb-3"
          ></multiselect>
        </div>
      </div>
      <footer class="modal-footer px-0 pb-0" v-if="!isCheckChangeShip">
        <button type="button" class="btn btn-secondary" @click="hideModal">Thôi</button>
        <button
            type="button"
            class="btn btn-primary"
            @click="onConfirmChangeShipper"
            :disabled="isBtnLoadingShip"
        >
          <template v-if="isBtnLoadingShip">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
            Đang xử lý...
          </template>
          <template v-else>Ok, chuyển giao hàng</template>
        </button>
      </footer>
    </b-modal>
  </Layout>
</template>